module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"duplicate":"Duplizieren (inkl. Benutzer definierten Szenario Massnahmen)"}}')
  delete Component.options._Ctor
}
